// |-- Built-in Dependencies --|
import React from "react";

// |-- External Dependencies --|
import { useSelector } from "react-redux";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";

// |-- Internal Dependencies --|
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
// import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";

// |-- Redux --|
import { RootState } from "src/redux/store";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

// |-- Types --|
type Props = {
  listHeading: string;
  onAddClick: () => void;
  listData: any[];
  searchValue?: string;
  OnSearchChange?: (newValue: string) => void;
  onListItemClick?: (item: any) => void;
  disabled: boolean;
  actionName?: string;
  onOuterGetActionDeleteClick?: (newValue: {
    label: string;
    value: string;
  }) => void;
  onOuterGetActionEditClick?: (newValue: {
    label: string;
    value: string;
  }) => void;
  hideAddButton?: boolean
};

const DispositionListView = ({
  listHeading,
  hideAddButton = false,
  onAddClick,
  listData,
  searchValue = "",
  OnSearchChange = (newValue: string) => { },
  onListItemClick = (item: any) => { },
  disabled = false,
  actionName = "",
  onOuterGetActionDeleteClick = (newValue: {
    label: string;
    value: string;
  }) => { },
  onOuterGetActionEditClick = (newValue: {
    label: string;
    value: string;
  }) => { },
}: Props) => {
  const { selectedLocationCountries }: any = useSelector(
    (state: RootState) => state.dispositionLevelOne
  );
  const { selectedLocationState }: any = useSelector(
    (state: RootState) => state.dispositionLevelTwo
  );

  const getActionOptions = (row: any) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          onOuterGetActionEditClick(row);
        },
        moduleName: UserModuleNameTypes.DISPOSITION,
        actionName: UserModuleActionTypes.EDIT,
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this disposition ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result.isConfirmed) {
                onOuterGetActionDeleteClick(row);
              }
            },
          });
        },
        moduleName: UserModuleNameTypes.DISPOSITION,
        actionName: UserModuleActionTypes.DELETE,
      },
    ];
  };

  return (
    <div className="border h-full w-full flex flex-col gap-1 rounded bg-white shadow-lg">
      <div className="border-b  text-slate-600 px-2 text-lg h-[50px] flex items-center justify-between ">
        {listHeading}

        {hideAddButton ? null :
          <button
            type="button"
            disabled={disabled}
            className="flex items-center gap-2 text-primary-main  text-sm h-[33px] px-4 rounded hover:bg-slate-100"
            onClick={() => {
              onAddClick();
            }}
          >
            {" "}
            + Add{" "}
          </button>
        }
      </div>

      <div className="h-[30px] px-2 border-b">
        {/* <ATMTextField
          name=""
          value={searchValue}
          onChange={(e) => {
            OnSearchChange(e.target.value);
          }}
          placeholder="Search"
          className="h-[30px] border-none"
        /> */}
      </div>

      <div className="max-h-[calc(100%-100px)]  overflow-hidden hover:overflow-auto">
        {listData?.map((listItem, listItemIndex) => {
          return (
            <div
              key={listItemIndex}
              onClick={() => {
                onListItemClick(listItem);
              }}
              className={`border-b border-slate-100 py-1 px-2 text-black-500 cursor-pointer flex justify-between items-center text-sm ${listItem.value !== undefined &&
                (selectedLocationCountries?.value === listItem.value ||
                  selectedLocationState?.value === listItem.value)
                ? "bg-gray-300"
                : ""
                }`}
            >
              {listItem.label}

              <ATMMenu
                iconSize={18}
                options={getActionOptions(listItem)}
                orientation="vertical"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DispositionListView;
